import React from "react";

const MessageBox = ({ information }) => {
  return (
    <>
      <div className="sim-alert">{information}</div>
    </>
  );
};

export default MessageBox;
